import {atom} from 'recoil'

const analyticLoading = atom({
  key: 'analytic-loading',
  default: false
});

const exportLoading = atom({
  key: 'export-loading',
  default: false
});

const analyticData = atom({
  key: 'analytic-data',
  default: {}
});

const analyticMessage = atom({
  key: 'analytic-message',
  default: {}
});

export {
  analyticLoading,
  exportLoading,
  analyticData,
  analyticMessage
}